import CheckIcon from "assets/check.svg";
import Text from "cms/components/Text";
import TypeFormButton from "cms/components/TypeFormButton";
import { ThemeMode } from "cms/theme/theme";
import { graphql } from "gatsby";
import React from "react";

import {
  ButtonContainer,
  Container,
  Content,
  ListItemIcon,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeadlineContainer,
  TableRow,
  TableWrapper,
} from "./FeatureComparisonBlock.styles";

export interface FeatureComparisonBlockProps
  extends Queries.SanityFeatureComparisonBlock {}

const FeatureComparisonBlock: React.FC<FeatureComparisonBlockProps> = ({
  headline,
  table,
  theme,
}) => (
  <Container>
    <Content>
      <TableHeadlineContainer>
        <Text variant="H3" as="h3">
          {headline}
        </Text>
      </TableHeadlineContainer>
      <TableWrapper>
        <Table>
          <TableCaption>{headline}</TableCaption>
          <TableHead>
            <TableRow $noBorder />
          </TableHead>

          <TableBody>
            {table?.rows?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row?.cells?.map((cell, cellIndex) => (
                  <React.Fragment key={cellIndex}>
                    <TableCell
                      key={cellIndex}
                      $isSticky={cellIndex === 0}
                      $passedTheme={theme as ThemeMode}
                    >
                      {(() => {
                        if (cell?.includes("[contact]")) {
                          return (
                            <ButtonContainer>
                              <TypeFormButton
                                label="Contact Sales"
                                variant="secondaryLight"
                              />
                            </ButtonContainer>
                          );
                        }

                        if (cell?.includes("[check]")) {
                          return (
                            <ListItemIcon>
                              <CheckIcon
                                fill={theme === "dark" ? "white" : "black"}
                              />
                            </ListItemIcon>
                          );
                        }

                        return cell ?? "";
                      })()}
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableWrapper>
    </Content>
  </Container>
);

export const query = graphql`
  fragment FeatureComparisonBlock on SanityFeatureComparisonBlock {
    _key
    _type
    headline
    table {
      rows {
        cells
      }
    }
    theme
  }
`;

export default FeatureComparisonBlock;
